"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ErrorMessageWrapper = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _onStage = require("@wix/wix-ui-icons-common/on-stage");
var _ErrorMessageWrapperSt = require("./ErrorMessageWrapper.deprecated.st.css");
var _types = require("./types");
var _jsxFileName = "/home/builduser/work/31dad9578a4e06bb/packages/wix-ui-tpa/dist/cjs/components/internal/ErrorMessageWrapper/ErrorMessageWrapper.tsx";
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
class ErrorMessageWrapper extends React.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_getMessage", () => {
      const {
        message,
        messageId
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        id: messageId,
        className: _ErrorMessageWrapperSt.classes.message,
        "data-hook": _types.ErrorMessageWrapperDataHooks.Message,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 17,
          columnNumber: 7
        }
      }, /*#__PURE__*/React.createElement(_onStage.ErrorSmall, {
        className: _ErrorMessageWrapperSt.classes.icon,
        "aria-hidden": true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22,
          columnNumber: 9
        }
      }), message);
    });
  }
  render() {
    const {
      className,
      children,
      visible,
      suffixText,
      'data-hook': dataHook
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: (0, _ErrorMessageWrapperSt.st)(_ErrorMessageWrapperSt.classes.root, {
        visible
      }, className),
      "data-hook": dataHook,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 7
      }
    }, children, visible && (suffixText ? /*#__PURE__*/React.createElement("div", {
      className: _ErrorMessageWrapperSt.classes.messageWithSuffix,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 13
      }
    }, this._getMessage(), suffixText) : this._getMessage()));
  }
}
exports.ErrorMessageWrapper = ErrorMessageWrapper;
(0, _defineProperty2.default)(ErrorMessageWrapper, "displayName", 'ErrorMessageWrapper');
(0, _defineProperty2.default)(ErrorMessageWrapper, "defaultProps", {
  visible: false
});
//# sourceMappingURL=ErrorMessageWrapper.js.map